import {
  Component,
  OnInit,
  Inject,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { DashboardService } from "../dashboard.service";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from "@angular/material/dialog";
import { FormBuilder, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { SharedService } from "src/app/shared/shared.service";
import { HttpErrorResponse } from "@angular/common/http";
import { HttpClient } from '@angular/common/http';
export interface DialogData {
  document: any;
  status: boolean;
}

@Component({
  selector: "app-attachment-popup",
  templateUrl: "./attachment-popup.component.html",
  styleUrls: ["./attachment-popup.component.scss"],
})
export class AttachmentPopupComponent implements OnInit {
  @ViewChild("rotatedImage") rotatedImage: ElementRef;
  tags: any = [];
  attachmentForm: FormGroup;
  attachmentDetails: any;
  imageExtension: any;
  validImg = ["jpg", "jpeg", "png"];
  rotation = 0;
  currentLanguage = "es";
  pipeLanguage = "es";
  loading: boolean = true;
  editMode: boolean = false;
  editAccess: boolean = true;
  newImageRotated = '';
  constructor(
    private dashboardService: DashboardService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private translationService: TranslateService,
    private sharedService: SharedService,
    public dialogRef: MatDialogRef<AttachmentPopupComponent>,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    if (this.data.status == true) {
      this.editAccess = true;
    } else {
      this.editAccess = false;
    }
    this.getallTags();
  }

  ngOnInit(): void {
    if (this.translationService.currentLang == "en-US") {
      this.currentLanguage = "en";
      this.pipeLanguage = this.translationService.currentLang;
    } else {
      this.currentLanguage = "es";
      this.pipeLanguage = "es-ES";
    }

    this.attachmentForm = this.fb.group({
      tags: [""],
      description: [""],
    });
  }

  getallTags() {
    this.dashboardService.getTags().subscribe({
      next: (res: any) => {
        this.tags = res.data;
        this.getAttachmentsInfo(this.data.document);
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }

  getAttachmentsInfo(document) {
    let patchTag;
    this.dashboardService.getAttachmentsInfo(document).subscribe({
      next: (res: any) => {
        this.attachmentDetails = res.data;
        console.log(res.data,'details');
        const { pathname } = new URL(res.data.url);
        this.imageExtension = pathname.split(".").pop().toLowerCase();
        
        if ( this.attachmentDetails.tag ) {
          for (var i = 0; i < this.tags.length; i++) {
            if ( this.tags[i]._id == this.attachmentDetails.tag.id ) {
              patchTag = this.tags[i];
            }
          }
          this.attachmentForm.patchValue({
            tags: patchTag,
          });
        }
        this.attachmentForm.patchValue({
          description: this.attachmentDetails.description,
        });
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    })
  }
  
  getImage() {
  const regex = /(\.jpg|\.jpeg|\.png)/i; 
  const newUrl = encodeURIComponent(this.attachmentDetails.url.split(regex)[0] + this.attachmentDetails.url.split(regex)[1]);
  this.dashboardService.uploadBase64(newUrl).subscribe({
    next:(res:any)=>{
      const originalBase64Image = "data:image/png;base64," + res; 
      this.processImage(originalBase64Image);
    },
    error:(error:HttpErrorResponse)=>{
      console.log(error,'error')
    }
  })
  }
  processImage(base64:any) {

    const img = new Image();

    img.onload = () => {  
      this.saveRotation(img);  
    }
    img.onerror = (error) => {
      console.error('Error loading image:', error);
    };
    img.src = base64;  
  }

  saveRotation(img: HTMLImageElement) {
    const canvas = document.createElement('canvas'); 
    const ctx = canvas.getContext('2d');

    const originalWidth = img.width; 
    const originalHeight = img.height;
    const absCos = Math.abs(Math.cos(this.rotation * Math.PI / 180));
    const absSin = Math.abs(Math.sin(this.rotation * Math.PI / 180));

    
    canvas.width = (absCos * originalWidth) + (absSin * originalHeight);
    canvas.height = (absCos * originalHeight) + (absSin * originalWidth);

    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(this.rotation * Math.PI / 180);
    ctx.drawImage(img, -img.width / 2, -img.height / 2);

    canvas.toBlob(blob => {
      this.uploadToBucket(blob);
    }, 'image/jpeg');
  }

  

  uploadToBucket(blob) {
    const fileName = this.attachmentDetails.name; 
    const file = new File([blob], fileName, { type: 'image/jpeg' });

    this.dashboardService.upload(file).subscribe({
      next: (res: any) => {
        console.log(res,'exito')
        this.newImageRotated = res.body.data;
        this.updateAttachment();
      },
      error: (error: HttpErrorResponse) => {
        console.log(error,'error')
      }
    }
    );
  }


  closePopup() {
    this.dialog.closeAll();
  }

  changeTags(val) {}

  enableEdit() {
    this.editMode = true;
  }
  rotateImg(value: number) {
    this.rotation += value;
  }

  validate() {
    if ( this.rotation != 0 ) {
      this.getImage();
    } else {
      this.updateAttachment();
    }
  }

  updateAttachment() {
    let data = {
      tag: this.attachmentForm.value["tags"]._id,
      description: this.attachmentForm.value["description"],
    };
    if(this.newImageRotated){
      data["url"] = this.newImageRotated;
    }
    this.dashboardService.getupdateAttachement(this.data.document, data).subscribe({
      next: (res: any) => {
        let patchTag;
        this.translationService
          .get("Attachment has been Updated Successfully")
          .subscribe((text: string) => {
            this.sharedService.showMessage(text, "success");
          });
          this.attachmentDetails = res.data;
        this.rotation = 0;
        let { pathname } = new URL(res.data.url);
        this.imageExtension = pathname.split(".").pop().toLowerCase();
        this.loading = false;
        if (this.attachmentDetails.tag) {
          for (var i = 0; i < this.tags.length; i++) {
            if (this.tags[i]._id == this.attachmentDetails.tag.id) {
              patchTag = this.tags[i];
            }
          }
          this.attachmentForm.patchValue({
            tags: patchTag,
          });
        }
        this.attachmentForm.patchValue({
          description: this.attachmentDetails.description,
        });
        this.editMode = false;
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }

  handleError(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = error.error.message;
      this.sharedService.showErrorMessage(errorMessage, "single");
    } else {
      // server-side error

      if (error.status == 422) {
        let values = [];
        for (let key in error.error.errors.messages) {
          values.push(error.error.errors.messages[key]);
        }
        this.sharedService.showMultipleErrors(values, "multi");
      } 
      else {
        if (typeof error?.error?.errors == "object") {
          errorMessage = error.error.errors.messages[0];
        } else {
          errorMessage = error.error.errors;
        }
        this.sharedService.showErrorMessage(errorMessage, "single");
      }
    }
  }
}
